import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "svg-icon",
  "aria-hidden": "true"
};
const _hoisted_2 = ["xlink:href"];
import store from "@/store";
import { onMounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { getvipuserv, getvipmenubymasterv, getpowerrouter } from "@/request/vipmenu";
import store1 from "../store/viptabls";
export default /*@__PURE__*/_defineComponent({
  __name: 'vipmenu',
  props: {
    ttype: String
  },
  setup(__props) {
    const props = __props;
    watch(() => props.ttype, (newVal, oldVal) => {
      ttype.value = newVal;
      getvipperson();
    });
    const ttype = ref();
    const router = useRouter();
    const viptype = ref("");
    const activeIndex2 = ref("1");
    const data = reactive({
      vipmenu: []
    });
    const getvipperson = () => {
      getvipuserv(store.state.owner, ttype.value).then(res => {
        viptype.value = res.data.data.type;
        if (res.data.data.parentid == "" || res.data.data.parentid == null) {
          getvipmenubymasterv(viptype.value).then(res => {
            data.vipmenu = res.data.data;
            store1.commit("resetState");
            store1.commit("addTab", data.vipmenu[0]);
            store.commit("setpowerList", data.vipmenu);
            activeIndex2.value = data.vipmenu[0].routerlink;
            router.push(data.vipmenu[0].routerlink);
          });
        } else {
          data.vipmenu = [];
          if (res.data.data.powername.charAt(0) == ',') {
            res.data.data.powername = res.data.data.powername.slice(1);
          }
          var dataname = res.data.data.powername.split(",");
          async function fetchData() {
            for (const name of dataname) {
              const response = await getpowerrouter(name, viptype.value);
              data.vipmenu.push(response.data.data[0]);
            }
            if (data.vipmenu.length > 0) {
              store1.commit("resetState");
              store1.commit("addTab", data.vipmenu[0]);
              store.commit("setpowerList", data.vipmenu);
              activeIndex2.value = data.vipmenu[0].routerlink;
              router.push(data.vipmenu[0].routerlink);
            }
          }
          fetchData();
        }
        store.commit("settype", res.data.data.type);
        var rangename = res.data.data.rangename.split(",");
        var rangeid = res.data.data.rangeid.split(",");
        var t = [];
        for (var i = 0; i < rangename.length; i++) {
          t.push({
            name: rangename[i],
            fid: rangeid[i]
          });
        }
        store.commit("setrangeList", t);
      });
    };
    const selectMenu = item => {
      activeIndex2.value = item.routerlink;
      store1.commit("addTab", item);
    };
    onMounted(() => {
      ttype.value = props.ttype;
      //getvipperson();
    });

    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_menu, {
        "default-active": activeIndex2.value,
        style: {
          "min-height": "700px"
        },
        "background-color": "#dce7f5",
        "text-color": "black",
        "active-text-color": "red",
        router: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.vipmenu, item => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            key: item.dataname,
            index: item.routerlink,
            onClick: $event => selectMenu(item)
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("use", {
              "xlink:href": '#icon-' + item.icon
            }, null, 8, _hoisted_2)])), _createElementVNode("span", null, _toDisplayString(item.dataname), 1)]),
            _: 2
          }, 1032, ["index", "onClick"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active"])]);
    };
  }
});